import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

// Fan onboarding now redirects directly to dashboard
// Dashboard handles player creation if none exist
export default function FanOnboarding() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to dashboard - it will show player creation if needed
    navigate('/dashboard', { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-white to-slate-50">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-purple-600 mx-auto mb-4" />
        <p className="text-slate-600">Setting up your dashboard...</p>
      </div>
    </div>
  );
}
